import { Component, effect, OnInit } from '@angular/core';
import { ProductService } from '../../../core/services/product.service';
import { PortalService } from '../../../core/services/portal.service';
import { PortalContextService } from '../../../core/services/portal-context.service';
import { SeoService } from '../../../core/services/seo.service';

@Component({
  selector: 'app-home',
  standalone: false,
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
  products = [] as any[]
  nameHomePage = ''
  desHomePage = ``
  loading = false
  primaryColor = '#333';
  constructor(
    private portalService: PortalService,
    private productService: ProductService,
    private portalContextService: PortalContextService,
    private seoService: SeoService
  ) {
    effect(() => {
      if (!this.portalService.loaded()) return;
      const portal = this.portalService.portal()!;
      this.primaryColor = portal.style.primary_color ?? '#333'
      this.fetchHomePage(portal)
    });
  }

  ngOnInit(): void {
    this.seoService.setPageSeo({
      title: 'Resource Centre',
      description: 'Browse product resources and downloads.',
      canonicalUrl: this.buildCanonicalUrl('/')
    });
  }

  fetchHomePage(portal: any) {
    const portalData = portal
    const portalId = portalData.id as string
    this.nameHomePage = portalData.name || ''
    this.desHomePage = portalData.description || ''

    const portalName = String(this.nameHomePage || '').trim();
    const pageTitle = portalName ? `${portalName} Resource Centre` : 'Resource Centre';
    const fallbackDescription = portalName
      ? `Browse products, resources, and downloads in the ${portalName} resource centre.`
      : 'Browse products, resources, and downloads in the resource centre.';
    this.seoService.setPageSeo({
      title: pageTitle,
      ogTitle: pageTitle,
      description: this.toMetaDescription(this.desHomePage, fallbackDescription),
      canonicalUrl: this.buildCanonicalUrl('/')
    });

    this.productService.getProductList(portalId).subscribe({
      next: (resProductList: any) => {
        const productList = Array.isArray(resProductList?.data) ? resProductList.data : [];
        this.products = productList.map((product: any) => ({
          width: 220,
          height: 153,
          code: product.sku,
          title: product.name,
          id: product.id,
          img: product.thumbnail_url,
          link: `/product/${product.sku}`
        }));
      },
      error: () => {
        this.products = [];
      }
    });
  }

  private buildCanonicalUrl(path: string): string {
    const baseUrl = this.portalContextService.getApiBaseUrl().replace(/\/+$/, '');
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return baseUrl ? `${baseUrl}${normalizedPath}` : normalizedPath;
  }

  private toMetaDescription(raw: string, fallback: string): string {
    const normalized = String(raw || '')
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return normalized || fallback;
  }
}
